import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getCourierList(status) {
    const params = { status };
    const url = '/couriers';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  showCourier(id) {
    return api.get(`/couriers/${id}`);
  },
  updateCourier(id, payload) {
    return api.put(`/couriers/${id}`, { courier: payload });
  },
  updateOrderCourier(payload) {
    return api.put(`couriers/update_order`, { couriers: payload });
  },
  hideCourier(id) {
    return api.delete(`/couriers/${id}`);
  },
  deleteCourier(id) {
    return api.delete(`/couriers/${id}/delete`);
  },
  restoreCourier(id) {
    return api.put(`/couriers/${id}/reactivate`);
  },
};
